import Auth from '../../../../../../auth';
export default function AlertsViewEditController($scope, $state, $stateParams, $uibModal, configurationsService, gettextCatalog) {

  'ngInject';

  $scope.contacts = [];
  $scope.contactsBackup = [];
  const configurationMenuItems = [];
  $scope.existingConfigurations = [];
  $scope.emailBackup = '';
  $scope.loading = true;
  $scope.maxEmails = 10;
  $scope.nameBackup = '';
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = "";

  //public methods
  $scope.editButtonClicked = editButtonClicked;
  $scope.isFormValid = isFormValid;

  init();

  function init() {
    getConfigurationById();
  }

  $scope.$on('totalEmails', function (event, totalEmails) {
    $scope.maxEmails = totalEmails.length;
  });

  //Switch to edit mode
  function editButtonClicked() {
    $scope.isEditing = !$scope.isEditing;
    if (!$scope.isEditing) {
      resetFormData();
    }
  }

  function loadConfigData() {
    $scope.contacts = [];
    //Provide a list of email objects for the multi-emails directive
    for (var i = 0; i < $scope.configuration.contacts.length; i++) {
      $scope.contacts.push({
        "email": $scope.configuration.contacts[i]
      });
    }
    resetFormData();
  }

  const resetFormData = () => {
    $scope.nameBackup =  angular.copy($scope.configuration.name);
    $scope.emailBackup = angular.copy($scope.contacts);
  }

  //Validate the form on submission then run the API call
  function isFormValid(editConfigurationForm) {
    editConfigurationForm.$setSubmitted();
    if (editConfigurationForm.$invalid) {
      $scope.loading = false;
      return;
    } else {
      $scope.submitEditConfigurationForm();
    }
  }

  $scope.configurationExists = function () {
    $scope.duplicateConfigName = false;
    configurationsService.getConfigurationByName($scope.configuration.name).then(function (response) {
      if ((response.data.name === $scope.configuration.name) && (response.data.id != $scope.configuration.id)) {
        $scope.duplicateConfigName = true;
      }
    }).catch(err => {
      if (404 != err.status)
        console.log(err)
    });
  }

  //Update the configuration name and contacts
  $scope.submitEditConfigurationForm = function () {
    $scope.loading = true;
    $scope.configErrorFlag = false;

    var id = $scope.configuration.id;
    var config = {
      name: '',
      contacts: [],
      brand: '',
    };

    config.name = $scope.nameBackup;

    for (var i = 0; i < $scope.emailBackup.length; i++) {
      config.contacts.push($scope.emailBackup[i].email);
    }

    const brand = Auth.getBrandClaim();

    if (brand != null) {
      config.brand = brand;
    }

    configurationsService.patchConfiguration(id, config)
      .then(function (response) {

        $scope.configuration.name = response.data.name;
        $scope.configuration.contacts = response.data.contacts;
        loadConfigData();
        $scope.loading = false;
        $scope.isEditing = false;

      })
      .catch(function (error) {
        var errorMsg = gettextCatalog.getString("An error occurred while updating the configuration");
        $scope.configErrorText = errorMsg;
        $scope.configErrorFlag = true;
      })
      .finally(function () {
        $scope.loading = false;
      });
  }; //End submitEditConfigurationForm

  $scope.deleteButtonPressed = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      template: require('../../delete-modal/delete.html'),
      controller: 'AlertsViewDeleteController',
      resolve: {
        configuration: function () {
          return $scope.configuration;
        }
      },
      size: 'md'
    });
  };

  function getConfigurationById() {
    if ($stateParams.configurationId) {

      //Do a call for the configuration data
      configurationsService.getConfigurationById($stateParams.configurationId)
        .then(function (response) {

          $scope.loading = false;
          $scope.configuration = response.data;

          //Populate Ui
          loadConfigData();

          //To let breadcrumbs directive know that the data for label has been loaded
          $scope.$emit('$viewContentLoaded');
        })
        .catch(function (error) {
          if (!$state.$current.parent.self.ncyBreadcrumbLabel) {
            if ($scope.$parent.selectedRow) {
              $state.$current.parent.self.ncyBreadcrumbLabel = $scope.$parent.selectedRow;
            } else {
              $state.$current.parent.self.ncyBreadcrumbLabel = "Error";
              $state.$current.parent.self.ncyBreadcrumbLink = $state.$current.parent.parent.self.ncyBreadcrumbLink;
            }
          }
          var errorMsg = gettextCatalog.getString("Unable to retrive Configuration information.");
          $scope.onLoadErrorFlag = true;
          $scope.onLoadErrorText = errorMsg;
        })
        .finally(function () {
          $scope.loading = false;
        });
    } else {
      $scope.loading = false;
      $scope.onLoadErrorFlag = true;
      $scope.onLoadErrorText = gettextCatalog.getString("Could not load page: no configuration Id provided.");
    }
  }

  configurationMenuItems.push({
    "title": "Manage Assets",
    "sref": "alerts.configurations.edit.equipment({configuration: configuration.id})"
  });

  configurationMenuItems.push({
    "title": "Manage Triggers",
    "sref": "alerts.configurations.edit.triggers({configuration: configuration.id})"
  });

  $scope.configurationMenuItems = configurationMenuItems;

  $scope.isActiveState = function (state) {
    return true;
  };
}